<template>
  <div>
    <h3 class="text-lg font-semibold">
      {{ $t('App.InvalidIntegration') }}
    </h3>
    <h5 class="text-xs font-medium text-flexopus-black/70 my-2">
      {{ $t('App.InvalidIntegrationDescription') }}
    </h5>
    <a
      target="_blank"
      :href="$t('App.HelpCenterLink')"
      class="text-sm text-flexopus-brand underline"
    >
      {{ $t('App.ReadMore') }}
    </a>
    <button
      class="btn btn-primary my-3 w-full"
      @click="$emit('reload')"
    >
      {{ $t('App.Reload') }}
    </button>
    <div class="divider my-6" />
    <plugin-details />
    <button
      class="btn btn-secondary mt-3 w-full"
      @click="$emit('logout')"
    >
      <LogOut class="w-5 h-5 mr-2" /> {{ $t('App.SignOut') }}
    </button>
  </div>
</template>

<script>
import PluginDetails from '@/components/PluginDetails.vue'
import { LogOut } from 'lucide-vue'

export default {
  components: {
    PluginDetails,
    LogOut,
  },
}
</script>

<style scoped>
</style>
